export enum FormSettingEnum {
    OFF = 0,
    ON = 1,
    REQUIRED = 2
}